import { render, staticRenderFns } from "./CustomerProduct.vue?vue&type=template&id=7a562ca2"
import script from "./CustomerProduct.vue?vue&type=script&lang=js"
export * from "./CustomerProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports